export default __webpack_public_path__ + "static/Lexend-Bold-1fcc930406ee6bdd15748ce6223103ac.woff2";